/**
 * @generated SignedSource<<afd1687bf7de96499510eed91bfa2a36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeactivateUserMutationInput = {
  clientMutationId?: string | null;
};
export type DeactivateUserMutation$variables = {
  input: DeactivateUserMutationInput;
};
export type DeactivateUserMutation$data = {
  readonly deactivateUser: {
    readonly clientMutationId: string | null;
    readonly viewer: {
      readonly id: string;
      readonly user: {
        readonly id: string;
      } | null;
    } | null;
    readonly user: {
      readonly id: string;
    } | null;
  } | null;
};
export type DeactivateUserMutation = {
  variables: DeactivateUserMutation$variables;
  response: DeactivateUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeactivateUserMutationPayload",
    "kind": "LinkedField",
    "name": "deactivateUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeactivateUserMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeactivateUserMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "13f38b172c39985324521a5ddf3f3bce",
    "id": null,
    "metadata": {},
    "name": "DeactivateUserMutation",
    "operationKind": "mutation",
    "text": "mutation DeactivateUserMutation(\n  $input: DeactivateUserMutationInput!\n) {\n  deactivateUser(input: $input) {\n    clientMutationId\n    viewer {\n      id\n      user {\n        id\n      }\n    }\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d2b5a3ae9d6402f8a73d83f3d42d795";

export default node;
